<template>
  <section>
    <CrearMovilidad />
    <Reporte />
    <VerInformacionInterinato/>
    <aprobar-tipo-movilidad />
    <suspencion-tipo-movilidad />
    <suspencion-interinato-movilidad />
    <anular-tipo-movilidad />
    <v-card v-if="funcionario === null">
      <v-card-text align="center">
        <v-progress-circular
          :size="70"
          :width="7"
          color="purple"
          indeterminate
        ></v-progress-circular>
      </v-card-text>
    </v-card>
    <v-card v-if="funcionario !== null">
      <v-card-text class="grey lighten-2 text--info">
        <v-layout wrap>
          <v-flex class="px-3">
            <v-btn v-if="$util.permisoRol([84])" icon color="primary" to="/persona/movilidad">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <strong>
              Movilidad
            </strong>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text>
        <v-container grid-list-md text-xs-center>
          <v-layout wrap>
            <v-flex md3>
              <v-icon v-if="urlFoto === ''" size="10rem">person</v-icon>
              <v-img
                v-if="urlFoto !== ''"
                :src="urlFoto"
                :lazy-src="urlFoto"
                heigth="10rem"
                width="10rem"
                class="grey lighten-2"
              >
                <template v-slot:placeholder>
                  <v-layout fill-height align-center justify-center ma-0>
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-layout>
                </template>
              </v-img>
            </v-flex>

            <v-flex md9>
              <v-layout wrap>
                <v-flex md6>
                  <strong>Nombre completo:</strong>
                  {{ funcionario.nombre }}
                </v-flex>
                <v-flex md6>
                  <strong>Número de documento: </strong>
                  {{ funcionario.nro_doc }}
                </v-flex>
                <v-flex md6>
                  <strong>Fecha de incorporación: </strong>
                  {{ fecha_ingreso!=null ? $moment(fecha_ingreso, "YYYY-MM-DD").format("DD/MM/YYYY") : 'Sin fecha de incorporación' }}
                </v-flex>
                <v-flex md6>
                  <strong>Ítem: </strong>
                  {{ funcionario.item }}
                </v-flex>
                <v-flex md6>
                  <strong>Estado servidor público: </strong>

                  <v-chip v-if="esActiva" color="rgba(100, 250, 50, 0.5)"
                    >Activo</v-chip
                  >
                  <v-chip v-if="!esActiva" color="rgba(240, 50, 50, 0.5)"
                    >Inactivo</v-chip
                  >
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-text class="grey lighten-2 text--info">
        <v-layout wrap>
          <v-flex class="px-3">
            <strong>
              Movimientos registrados
            </strong>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text>
    
        <v-layout>
          <v-tooltip bottom>
            <v-btn
              v-if="!filterShow"
              class="btn-refresh"
              icon
              slot="activator"
              @click="
                v => {
                  filterShow = true;
                }
              "
            >
              <v-icon>filter_list</v-icon>
            </v-btn>
            <span>Filtros</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              v-if="filterShow"
              class="btn-refresh"
              icon
              slot="activator"
              @click="
                v => {
                  filterShow = false;
                }
              "
            >
              <v-icon>filter_list</v-icon>
            </v-btn>
            <span>Ocultar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              @click.native="obtenerDatos()"
              class="btn-refresh"
              slot="activator"
              ><v-icon>refresh</v-icon>
            </v-btn>
            <span>{{ $t("common.updateList") }}</span>
          </v-tooltip>
        </v-layout>
        <v-layout row wrap v-if="filterShow">
          <v-flex xs2>
            <v-text-field
              append-icon="search"
              type="number"
              label="Item"
              single-line
              hide-details
              @input="filterItem"
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-text-field
              append-icon="search"
              label="Fecha desde"
              single-line
              hide-details
              @input="filterFechaDesde"
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-text-field
              append-icon="search"
              label="Fecha conclusión"
              single-line
              hide-details
              @input="filterFechaHasta"
            ></v-text-field>
          </v-flex>

          <v-flex xs2>
            <v-text-field
              append-icon="search"
              label="Fecha de registro"
              single-line
              hide-details
              @input="filterFechaRegistro"
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-text-field
              append-icon="search"
              label="Tipo de movimiento"
              single-line
              hide-details
              @input="filterTipoMovimiento"
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-text-field
              append-icon="search"
              label="Unidad"
              single-line
              hide-details
              @input="filterUnidad"
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-text-field
              append-icon="search"
              label="Cargo"
              single-line
              hide-details
              @input="filterCargo"
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-text-field
              append-icon="search"
              label="Puesto"
              single-line
              hide-details
              @input="filterPuesto"
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-text-field
              append-icon="search"
              label="Nro de memorándum"
              single-line
              hide-details
              @input="filterNroMemorandum"
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-text-field
              append-icon="search"
              label="Estado"
              single-line
              hide-details
              @input="filterEstado"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <!-- :loading="vMovimientosMovilidads.length == 0" -->
            <v-data-table
              :headers="headers"
              :items="vMovimientosMovilidads"
              class="elevation-1"
              item-key="id"
              :search="filters"
              :custom-filter="customFilter"
              no-data-text="Sin datos"
              :rows-per-page-items="[10, 25, { text: 'Todos', value: -1 }]"
            >
              <!-- <template slot="headers" slot-scope="props">
                <tr >
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template> -->
              <template v-slot:items="items">
                <td
                  :class="
                    items.item.id_estado == 1 || items.item.id_estado == 53
                      ? 'colorActivo'
                      : 'text-xs-center'
                  "
                >
                  {{ items.item.nro_item }}
                </td>
                <td
                  :class="
                    items.item.id_estado == 1 || items.item.id_estado == 53
                      ? 'colorActivo'
                      : 'text-xs-center'
                  "
                >
                  {{ items.item.fecha_desde }}
                </td>
                <td
                  :class="
                    items.item.id_estado == 1 || items.item.id_estado == 53
                      ? 'colorActivo'
                      : 'text-xs-center'
                  "
                >
                  {{ items.item.fecha_hasta }}
                </td>
                <td
                  :class="
                    items.item.id_estado == 1 || items.item.id_estado == 53
                      ? 'colorActivo'
                      : 'text-xs-center'
                  "
                >
                  {{ items.item.fecha_registro }}
                </td>
                <td
                  :class="
                    items.item.id_estado == 1 || items.item.id_estado == 53
                      ? 'colorActivo'
                      : 'text-xs-center'
                  "
                >
                  {{ items.item.tipo_movimiento }}
                </td>
                <td
                  :class="
                    items.item.id_estado == 1 || items.item.id_estado == 53
                      ? 'colorActivo'
                      : 'text-xs-center'
                  "
                >
                  {{ items.item.unidad }}
                </td>
                <td
                  :class="
                    items.item.id_estado == 1 || items.item.id_estado == 53
                      ? 'colorActivo'
                      : 'text-xs-center'
                  "
                >
                  {{ items.item.cargo }}
                </td>
                <td
                  :class="
                    items.item.id_estado == 1 || items.item.id_estado == 53
                      ? 'colorActivo'
                      : 'text-xs-center'
                  "
                >
                  {{ items.item.puesto }}
                </td>
                <td
                  :class="
                    items.item.id_estado == 1 || items.item.id_estado == 53
                      ? 'colorActivo'
                      : 'text-xs-center'
                  "
                >
                  {{ items.item.nro_memorandum }}
                </td>
                <td
                  :class="
                    items.item.id_estado == 1 || items.item.id_estado == 53
                      ? 'colorActivo'
                      : 'text-xs-center'
                  "
                >
                  <v-chip
                    color="green"
                    text-color="white"
                    v-if="items.item.estado === 'Programado'"
                    >Aprobado
                  </v-chip>
                  <v-chip
                    color="green"
                    text-color="white"
                    v-if="items.item.estado === 'Concluido'"
                    >Aprobado
                  </v-chip>
                  <v-chip
                    color="green"
                    text-color="white"
                    v-if="items.item.estado === 'Aprobado'"
                    >{{ items.item.estado }}
                  </v-chip>
                  <v-chip
                    color="green"
                    text-color="white"
                    v-if="items.item.estado === 'Alta Temporal'"
                    >Aprobado</v-chip
                  >
                  <v-chip
                    color="green"
                    text-color="white"
                    v-if="items.item.estado === 'Suspendido'"
                    >Aprobado</v-chip
                  >
                  <v-chip
                    color="green"
                    text-color="white"
                    v-if="items.item.estado === 'Baja'"
                    >Aprobado</v-chip
                  >
                  <v-chip
                    color="green"
                    text-color="white"
                    v-if="items.item.estado === 'Baja Temporal'"
                    >Aprobado</v-chip
                  >
                  <v-chip
                    color="brown"
                    text-color="white"
                    v-if="items.item.estado === 'Rechazado'"
                    >{{ items.item.estado }}</v-chip
                  >
                  <v-chip
                    color="orange"
                    text-color="white"
                    v-if="items.item.estado === 'Pendiente'"
                    >{{ items.item.estado }}</v-chip
                  >
                </td>
                <td
                  :class="
                    items.item.id_estado == 1 || items.item.id_estado == 53
                      ? 'colorActivo'
                      : 'text-xs-center'
                  "
                >
                  <v-btn
                    color="rgba(177, 17, 167,0.6)"
                    icon
                    title="Ver informacion"
                    @click.prevent="verInformacionInterinato(items.item)"
                    v-if="
                      items.item.id_tipo_justificacion==11"
                  >
                    <v-icon>visibility</v-icon>
                  </v-btn>

                  <v-btn
                    color="blue"
                    icon
                    title="Memorandum"
                    @click.prevent="reporte(items.item)"
                    :loading="loading_memos"
                    :disabled="loading_memos"
                    v-if="
                      !items.item.cargoEspecial &&
                        (items.item.id_tipo_justificacion == 7 ||
                          items.item.id_tipo_justificacion == 2 ||
                          items.item.id_tipo_justificacion == 1 ||
                          items.item.id_tipo_justificacion == 11) &&
                        (items.item.id_estado == 1 ||
                          items.item.id_estado == 53 ||
                          items.item.id_estado == 63 ||
                          items.item.id_estado == 52 ||
                          items.item.id_estado == 2 ||
                          items.item.id_estado == 64)
                    "
                  >
                    <v-icon>description</v-icon>
                  </v-btn>
                  <v-btn
                    color="purple"
                    icon
                    title="Resolucion"
                    @click.prevent="reporte2(items.item)"
                    :loading="loading_memos"
                    :disabled="loading_memos"
                    v-if="
                      !items.item.cargoEspecial &&
                        items.item.id_tipo_justificacion == 7 &&
                        (items.item.id_estado == 1 ||
                          items.item.id_estado == 53 ||
                          items.item.id_estado == 63 ||
                          items.item.id_estado == 52 ||
                          items.item.id_estado == 2 ||
                          items.item.id_estado == 64)
                    "
                  >
                    <v-icon>description</v-icon>
                  </v-btn>
                  <!--
                    ****************************************************************
                    ****************************************************************

                    NO BORRAR --------------------- IMPORTANTE 

                    ****************************************************************
                    ****************************************************************
                  -->
                  <!-- <v-btn
                    color="blue"
                    icon
                    title="Memorandum renuncia sin vacacion"
                    @click.prevent="reporte3(items.item)"
                    v-if="
                      items.item.bandera == 1 &&
                        items.item.id_tipo_justificacion == 6 &&
                        items.item.id_estado != 32
                    "
                  >
                    <v-icon>description</v-icon>
                  </v-btn>
                  <v-btn
                    color="blue"
                    icon
                    title="Memorandum renuncia con vacacion"
                    @click.prevent="reporte4(items.item)"
                    v-if="
                      items.item.bandera == 1 &&
                        items.item.id_tipo_justificacion == 6 &&
                        items.item.id_estado != 32
                    "
                  >
                    <v-icon>description</v-icon>
                  </v-btn> -->
                  <v-btn
                    color="blue"
                    icon
                    title="Memorandum suspension"
                    @click.prevent="reporte5(items.item)"
                    v-if="
                      items.item.id_tipo_justificacion == 14 &&
                        items.item.id_estado != 32 &&
                        items.item.id_estado == 18
                    "
                  >
                    <v-icon>description</v-icon>
                  </v-btn>
                  <v-btn
                    color="blue"
                    icon
                    title="Memorandum desvinculacion sin vacación"
                    @click.prevent="reporte6(items.item)"
                    :loading="loading_memos"
                    :disabled="loading_memos"
                    v-if="
                      items.item.bandera == 1 &&
                        items.item.id_tipo_justificacion == 5 &&
                        (items.item.id_estado == 1 ||
                          items.item.id_estado == 53 ||
                          items.item.id_estado == 63 ||
                          items.item.id_estado == 52 ||
                          items.item.id_estado == 2 ||
                          items.item.id_estado == 64)
                    "
                  >
                    <v-icon>description</v-icon>
                  </v-btn>
                  <v-btn
                    color="blue"
                    icon
                    title="Memorandum desvinculacion con vacación"
                    @click.prevent="reporte7(items.item)"
                    :loading="loading_memos"
                    :disabled="loading_memos"
                    v-if="
                      items.item.bandera == 1 &&
                        items.item.id_tipo_justificacion == 5 &&
                        (items.item.id_estado == 1 ||
                          items.item.id_estado == 53 ||
                          items.item.id_estado == 63 ||
                          items.item.id_estado == 52 ||
                          items.item.id_estado == 2 ||
                          items.item.id_estado == 64)
                    "
                  >
                    <v-icon>description</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import CrearMovilidad from "./dialogs/CrearMovilidad.vue";
import AprobarTipoMovilidad from "./dialogs/AprobarTipoMovilidad";
import AnularTipoMovilidad from "./dialogs/AnularTipoMovilidad";
import SuspencionTipoMovilidad from "./dialogs/SuspencionTipoMovilidad.vue";
import SuspencionInterinatoMovilidad from "./dialogs/SuspencionInterinatoMovilidad.vue";
import VerInformacionInterinato from "./dialogs/VerInformacionInterinato.vue";
import Reporte from "./dialogs/Reporte";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  // Variables iniciales del componente
  data() {
    return {
      url: "vMovimientosMovilidads",
      graphql: true,
      urlFoto: "",
      filterShow: false,
      loading: true,
      loading_memos: true,
      fecha_ingreso:'',
      filters: {
        nro_item: "",
        fecha_desde: "",
        fecha_hasta: "",
        fecha_registro: "",
        tipo_movimiento: "",
        unidad: "",
        cargo: "",
        puesto: "",
        nro_memorandum: "",
        estado: ""
      },
      // Cabecera de la tabla
      headers: [
        { text: "ITEM", value: "nro_item", sortable: true, align: "center" },
        {
          text: "Fecha desde",
          value: "fecha_desde",
          sortable: true,
          align: "center"
        },
        {
          text: "Fecha de conclusión",
          value: "fecha_hasta",
          sortable: true,
          align: "center"
        },
        {
          text: "Fecha de registro",
          value: "fecha_registro",
          sortable: true,
          align: "center"
        },
        {
          text: "Tipo de movimiento",
          value: "tipo_movimiento",
          sortable: true,
          align: "center"
        },
        { text: "Unidad", value: "unidad", sortable: true, align: "center" },

        { text: "Cargo", value: "cargo", sortable: true, align: "center" },
        { text: "Puesto", value: "puesto", sortable: true, align: "center" },
        {
          text: "Nro. Memorándum",
          value: "nro_memorandum",
          sortable: true,
          align: "center"
        },
        { text: "Estado", value: "estado", sortable: true, align: "center" },
        { text: "Acciones", sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id
        id_persona
        nro_doc
        fecha_desde
        fecha_hasta
        fecha_registro
        cargo
        puesto
        unidad
        nro_item
        tipo_movimiento
        nro_memorandum
        estado
        id_estado
        id_tipo_justificacion
        id_puesto
        id_unidad
        id_cargo
        sueldo
        padres_unidad
        bandera
      `,
      initData: [],
      funcionario: null,
      funcionario1: null,
      vMovimientosMovilidads: [],
      nueva_movilidad: true,
      nueva_asignacion: true,
      // Variable para determinar si una persona es activa o pasiva
      esActiva: false
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {  //
      this.$router.push("/403");
    }
    await this.verificaPersonaActiva();
    await this.obtenerDatos();
    await this.cargarCargosEspeciales();
    
     this.$bus.$on("closeDialogVerInformacionInterinato", async () => {
    });
    this.$bus.$on("closeDialogMovilidad", async () => {
      this.nueva_asignacion = true;
      this.nueva_movilidad = true;
      await this.verificaPersonaActiva();
      await this.obtenerDatos();
      await this.cargarCargosEspeciales();
    });
    this.$bus.$on("closeDialogCrearMovilidad", async () => {
      this.nueva_asignacion = true;
      this.nueva_movilidad = true;
      await this.verificaPersonaActiva();
      await this.obtenerDatos();
      await this.cargarCargosEspeciales();
    }); 
    this.$bus.$on("closeDialogAprobar", async () => {
      this.nueva_asignacion = true;
      this.nueva_movilidad = true;
      await this.verificaPersonaActiva();
      await this.obtenerDatos();
      await this.cargarCargosEspeciales();
    });
    this.$bus.$on("closeDialogAprobarReestructuracion", async () => {
      this.nueva_asignacion = true;
      this.nueva_movilidad = true;
      await this.verificaPersonaActiva();
      await this.obtenerDatos();
      await this.cargarCargosEspeciales();
    });

  },
  // Métodos y funciones del componente
  methods: {
    // Metodo para determinar si una persona es activa o pasiva
    async verificaPersonaActiva() {
      try {
        let user = this.$storage.get("user");
        let respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta: "SELECT movilidad.fn_funcionario_pasivo_activo(${parseInt(
                  user.id_persona
                )})"){
                  respuesta
                }
              }
            `
        });
        respuesta =
          respuesta.runQuery.respuesta[0].fn_funcionario_pasivo_activo;
        respuesta = respuesta.split("|");
        if (respuesta[0] == "1") {
          if (respuesta[1] == "Activo") {
            this.esActiva = true;
          } 
          else {
            this.esActiva = false;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerDatos() {
       let user = this.$storage.get("user");
      //obtener fecha de ingreso.
        let rpta = await this.$service.graphql({
          query: `
							 query{
                runQuery(consulta: "select movilidad.fn_fecha_ultima_incorporacion(${user.id_persona})"){
                  respuesta
                }
              }
					`
        });
        if (rpta.runQuery.respuesta[0].fn_fecha_ultima_incorporacion) {
          let rpta2=rpta.runQuery.respuesta[0].fn_fecha_ultima_incorporacion.split('|')
          if (rpta2[0]==1) {
              this.fecha_ingreso =rpta2[1]
          }else{ this.fecha_ingreso ='Sin fecha de incorporación'}
        }
      let res = await this.$service.graphql({
        query: `
          query get($id: ID!){
            vListaPersonal(id: $id){
              nombre
              id_movilidad
              nro_doc
              fecha_ingreso
              item
              foto
              id_persona
              id_estado
              id_item
              puesto
    					cargo
    					unidad
              padres_unidad
    					sueldo
            }
          }
        `,
        variables: {
          id: user.id_persona
        }
      });
      // if (res.vListaPersonal.id_estado == 2) {
      //   this.$router.push("/401");
      // }
      if (res.vListaPersonal) {
        this.funcionario = res.vListaPersonal;
      this.obtenerFoto();
      res = await this.$service.graphql({
        query: `
          query{
            vMovimientosMovilidads(id_persona: ${this.funcionario.id_persona}){
              rows{
                id
                id_persona
                nro_doc
                fecha_desde
                fecha_hasta
                fecha_registro
                cargo
                puesto
                unidad
                nro_item
                tipo_movimiento
                nro_memorandum
                id_tipo_justificacion
                id_puesto
                id_unidad
                id_cargo
                id_estado
                estado
                sueldo
                padres_unidad
                bandera
                id_item
              }
            }
          }
        `
      });
      this.vMovimientosMovilidads = res.vMovimientosMovilidads.rows;
      this.vMovimientosMovilidads.forEach(item => {
        if (item.id_estado == 5 || item.id_estado == 64) {
          return (this.nueva_movilidad = false);
        }
      });
      this.vMovimientosMovilidads.forEach(item => {
        if (
          item.id_estado == 1 &&
          item.id_tipo_justificacion != 5 &&
          item.id_tipo_justificacion != 6 &&
          item.id_tipo_justificacion != 10 &&
          item.id_tipo_justificacion != 13
        ) {
          return (this.nueva_asignacion = false);
        }
      });
      // Verificando cargos especiales
      for (let index = 0; index < this.vMovimientosMovilidads.length; index++) {
        const element = this.vMovimientosMovilidads[index];
        element.cargoEspecial = false;
      }
      // Obteniendo datos de la movilidad alta (1) del funcionario
      res = await this.$service.graphql({
        query: `
          query{
            vMovimientosMovilidads(id_persona: ${this.funcionario.id_persona},id_estado:1){
              rows{
                id
                id_persona
                nro_doc
                fecha_desde
                fecha_hasta
                fecha_registro
                cargo
                puesto
                unidad
                nro_item
                tipo_movimiento
                nro_memorandum
                id_tipo_justificacion
                id_puesto
                id_unidad
                id_cargo
                id_estado
                estado
                sueldo
                padres_unidad
                bandera
              }
            }
          }
        `
      });
      this.vMovimientosMovilidadsfiltro = res.vMovimientosMovilidads.rows;
      this.loading = false;
      }     
    },
    async cargarCargosEspeciales() {
      // Verificando cargos especiales
      let lista_aux = [...this.vMovimientosMovilidads];
      for (let index = 0; index < lista_aux.length; index++) {
        const element = lista_aux[index];
        element.cargoEspecial = await this.compruebaCargoEspecial(
          element.id_tipo_justificacion,
          element.nro_item
        );
      }
      this.vMovimientosMovilidads = lista_aux;
      this.loading_memos = false;
    },
    async compruebaCargoEspecial(id_tipo_justificacion, nro_item) {
      try {
        let es_especial = false;
        let res;
        // Reasigacion
        if (id_tipo_justificacion == 1 || id_tipo_justificacion == 7) {
          res = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta: "SELECT movilidad.fn_pregunta_cargo_jerarquico_por_item(${parseInt(
                  nro_item
                )})"){
                  respuesta
                }
              }
            `
          });
          res = res.runQuery.respuesta[0].fn_pregunta_cargo_jerarquico_por_item;
        }
        // Retiro por desvinculacion
        else if (id_tipo_justificacion == 5) {
          res = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta: "SELECT movilidad.fn_pregunta_cargo_viceministros_por_item(${parseInt(
                  nro_item
                )})"){
                  respuesta
                }
              }
            `
          });
          res =
            res.runQuery.respuesta[0].fn_pregunta_cargo_viceministros_por_item;
        }
        // Interinato
        else if (id_tipo_justificacion == 11) {
          res = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta: "SELECT movilidad.fn_pregunta_cargo_vice_direc_por_item(${parseInt(
                  nro_item
                )})"){
                  respuesta
                }
              }
            `
          });
          res = res.runQuery.respuesta[0].fn_pregunta_cargo_vice_direc_por_item;
        }
        if (res) {
          res = res.split("|");
          if (parseInt(res[0]) == 1) {
            if (res[1] == "SI") {
              es_especial = true;
            }
          } else {
            this.$message.error(res[1]);
          }
        }
        return es_especial;
      } catch (error) {
        console.log(error);
      }
    },
    crearMovilidad(item) {
      item.nueva_asignacion = this.nueva_asignacion;
      item = { ...item, ...this.vMovimientosMovilidadsfiltro[0] };
      this.$bus.$emit("openDialogCrearMovilidad", item);
    },
    aprobarMovilidad(item) {
      item.funcionario = this.funcionario;
      this.$bus.$emit("openDialogAprobarTipoMovilidad", item);
    },
    suspencionMovilidad(item) {
      item.funcionario = this.funcionario;
      this.$bus.$emit("openDialogSuspencionTipoMovilidad", item);
    },
    suspencionInterinatoMovilidad(item) {
      item.funcionario = this.funcionario;
      this.$bus.$emit("openDialogSuspencionInterinatoMovilidad", item);
    },
    eliminarMovilidad(item) {
      item.funcionario = this.funcionario;
      this.$bus.$emit("openDialogAnularTipoMovilidad", item);
    },
    verInformacionInterinato(item) {

      this.$bus.$emit("openDialogVerInformacionInterinato", item);
    },
    editarMovilidad(item) {
      item.funcionario = this.funcionario;
      if (item.fecha_desde) {
        item.fecha_desde = this.formatDate(item.fecha_desde);
      }
      if (item.fecha_hasta) {
        item.fecha_hasta = this.formatDate(item.fecha_hasta);
      }
      item.editar = true;
      this.$bus.$emit("openDialogEditarMovilidad", item);
    },

    editarMovilidadFecha(item) {
      item = { ...item, ...this.vMovimientosMovilidads[0] };
      item.funcionario = this.funcionario;

      if (item.fecha_desde) {
        item.fecha_desde = this.formatDate(item.fecha_desde);
      }
      if (item.fecha_hasta) {
        item.fecha_hasta = this.formatDate(item.fecha_hasta);
      }
      item.editar = true;
      this.$bus.$emit("openDialogEditarMovilidadFecha", item);
    },

    crearPersona() {
      this.$bus.$emit("openDialogCrearPersona");
    },
    formatDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    obtenerTipo(url) {
      const archivo = url.split(".");
      return archivo[1];
    },
    obtenerFoto() {
      if (this.funcionario.foto) {
        const api_backend = process.env.API_URL.split("api/");
        this.urlFoto = api_backend[0] + this.funcionario.foto;
      }
    },
    reporte(item) {
      let user = this.$storage.get("user");
      let nombre_reporte = "";
      if (item.id_tipo_justificacion == 7)
        nombre_reporte = "memorandum_incorporacion";
      if (item.id_tipo_justificacion == 1)
        nombre_reporte = "reasignacion_cargo";
      if (item.id_tipo_justificacion == 2)
        nombre_reporte = "comision_servicios";
      if (item.id_tipo_justificacion == 11) nombre_reporte = "memo_interinato";
      let formato_doc = "output=rtf";
      let nombre_carpeta = "memos";
      let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
        /{carpeta}/g,
        nombre_carpeta
      );
      let url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
      //Parametros
      let nro = item.id;
      // URL con parametros
      let url_parametros = `${url}&id=${nro}`;
      console.log(url_parametros);
      this.$bus.$emit("openDialogReporte", url_parametros);
    },
    reporte2(item) {
      let user = this.$storage.get("user");
      let nombre_reporte = "resolucion_administrativa_Incorporacion";
      let formato_doc = "output=rtf";
      let nombre_carpeta = "memos";
      let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
        /{carpeta}/g,
        nombre_carpeta
      );
      let url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
      //Parametros
      let nro = item.id;
      // URL con parametros
      let url_parametros = `${url}&id=${nro}`;
      this.$bus.$emit("openDialogReporte", url_parametros);
    },
    reporte3(item) {
      let user = this.$storage.get("user");
      let nombre_reporte = "memo_retiroRenuncia";
      let formato_doc = "output=rtf";
      let nombre_carpeta = "memos";
      let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
        /{carpeta}/g,
        nombre_carpeta
      );
      let url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
      //Parametros
      let nro = item.id;
      // URL con parametros
      let url_parametros = `${url}&id=${nro}&VACACION=0`;
      this.$bus.$emit("openDialogReporte", url_parametros);
    },
    reporte4(item) {
      let user = this.$storage.get("user");
      let nombre_reporte = "memo_retiroRenuncia";
      let formato_doc = "output=rtf";
      let nombre_carpeta = "memos";
      let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
        /{carpeta}/g,
        nombre_carpeta
      );
      let url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
      //Parametros
      let nro = item.id;
      // URL con parametros
      let url_parametros = `${url}&id=${nro}&VACACION=1`;
      this.$bus.$emit("openDialogReporte", url_parametros);
    },
    reporte5(item) {
      let user = this.$storage.get("user");
      let nombre_reporte = "memo_suspension";
      let formato_doc = "output=rtf";
      let nombre_carpeta = "memos";
      let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
        /{carpeta}/g,
        nombre_carpeta
      );
      let url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
      //Parametros
      let nro = item.id;
      // URL con parametros
      let url_parametros = `${url}&id=${nro}`;
      this.$bus.$emit("openDialogReporte", url_parametros);
    },
    reporte6(item) {
      let user = this.$storage.get("user");
      let nombre_reporte = "memo_Desvinculacion";
      let formato_doc = "output=rtf";
      let nombre_carpeta = "memos";
      let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
        /{carpeta}/g,
        nombre_carpeta
      );
      let url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
      //Parametros
      let nro = item.id;
      // URL con parametros
      let url_parametros = `${url}&id=${nro}&VACACION=0`;
      this.$bus.$emit("openDialogReporte", url_parametros);
    },
    reporte7(item) {
      let user = this.$storage.get("user");
      let nombre_reporte = "memo_Desvinculacion";
      let formato_doc = "output=rtf";
      let nombre_carpeta = "memos";
      let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
        /{carpeta}/g,
        nombre_carpeta
      );
      let url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
      //Parametros
      let nro = item.id;
      // URL con parametros
      let url_parametros = `${url}&id=${nro}&VACACION=1`;
      this.$bus.$emit("openDialogReporte", url_parametros);
    },
    customFilter(items, filters, filter, headers) {
      // Init the filter class.
      const cf = new this.$MultiFilters(items, filters, filter, headers);
      cf.registerFilter("nro_item", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          return (item.nro_item + "")
            .toLowerCase()
            .includes(searchWord.toLowerCase());
        }, searchWord);
      });
      cf.registerFilter("fecha_desde", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          return item.fecha_desde
            .toLowerCase()
            .includes(searchWord.toLowerCase());
        }, searchWord);
      });
      cf.registerFilter("fecha_hasta", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          if (item.fecha_hasta != null) {
            return item.fecha_hasta
              .toLowerCase()
              .includes(searchWord.toLowerCase());
          } else {
            return "".toLowerCase().includes(searchWord.toLowerCase());
          }
        }, searchWord);
      });
      cf.registerFilter("fecha_registro", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          return item.fecha_registro
            .toLowerCase()
            .includes(searchWord.toLowerCase());
        }, searchWord);
      });
      cf.registerFilter("tipo_movimiento", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          return item.tipo_movimiento
            .toLowerCase()
            .includes(searchWord.toLowerCase());
        }, searchWord);
      });
      cf.registerFilter("unidad", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          return item.unidad.toLowerCase().includes(searchWord.toLowerCase());
        }, searchWord);
      });
      cf.registerFilter("cargo", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          return item.cargo.toLowerCase().includes(searchWord.toLowerCase());
        }, searchWord);
      });
      cf.registerFilter("puesto", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          return item.puesto.toLowerCase().includes(searchWord.toLowerCase());
        }, searchWord);
      });
      cf.registerFilter("nro_memorandum", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          return item.nro_memorandum
            .toLowerCase()
            .includes(searchWord.toLowerCase());
        }, searchWord);
      });
      cf.registerFilter("estado", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          return item.estado.toLowerCase().includes(searchWord.toLowerCase());
        }, searchWord);
      });
      return cf.runFilters();
    },
    filterItem(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        nro_item: val
      });
    },
    filterFechaDesde(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        fecha_desde: val
      });
    },
    filterFechaHasta(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        fecha_hasta: val
      });
    },
    filterFechaRegistro(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        fecha_registro: val
      });
    },
    filterTipoMovimiento(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        tipo_movimiento: val
      });
    },
    filterUnidad(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        unidad: val
      });
    },
    filterCargo(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        cargo: val
      });
    },
    filterPuesto(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        puesto: val
      });
    },
    filterNroMemorandum(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        nro_memorandum: val
      });
    },
    filterEstado(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        estado: val
      });
    }
  },

  // Definición de componentes importados
  components: {
    CrudTable,
    CrearMovilidad,
    AprobarTipoMovilidad,
    AnularTipoMovilidad,
    SuspencionTipoMovilidad,
    SuspencionInterinatoMovilidad,
    Reporte,
    VerInformacionInterinato
  }
};
</script>
<style>
.colorActivo {
  background-color: rgba(211, 255, 91, 0.808);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/MovilidadFuncionario.vue